module.exports = __webpack_public_path__ + "img/Wp_2020.0c9b2133.png";